module.exports = __webpack_public_path__ + "static/media/registration-anomalies.7c012a34.png";